export var FetchStates;
(function (FetchStates) {
    FetchStates["IDLE"] = "idle";
    FetchStates["LOADING"] = "loading";
    FetchStates["SUCCESS"] = "success";
    FetchStates["FAILURE"] = "failure";
})(FetchStates || (FetchStates = {}));
//# sourceMappingURL=FetchStates.js.map